import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import WidgetBox from '@wix/da-gruser-shared/pkg/components/WidgetBox';
import useModulePrivileges from '@wix/da-gruser-shared/pkg/hooks/useModulePrivileges';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PremiumFolderDataIcon from '../../../GallectionFolderDropdown/_partials/PremiumFolderDataIcon';
import ExhibitionistStrip from '../ExhibitionistStrip';
import ExhibitionistGrid from '../ExhibitionistGrid';
import ExhibitionistEmpty from '../ExhibitionistEmpty';
import { GallectionType } from '../../../types/gallection';
import FavouritesLabel from '../_partials/FavouritesLabel';
import { getCurrentUserHasCore } from '../../../publicSession/selectors';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import ConditionalWrapper from '../../../ConditionalWrapper/ConditionalWrapper';
import WidgetPaywall from '../_partials/WidgetPaywall/WidgetPaywall';
import { ExhibitionistViewMode } from '../ExhibitionistConfigPopover/types';
import ExhibitionistSlideshow from '../ExhibitionistSlideshow';
import DuperbrowseContext from '../../../Duperbrowse/DeviationDuperbrowseContext';
import { EXHIBITIONIST_STRIP_DUPERBROWSE_STREAMID } from '../consts';
import { useExhibitionistType } from '../hooks';
import { ExhibitionistWidgetType } from '../types';
import s from './ExhibitionistBox.scss';
const ExhibitionistBox = ({ moduleId, widgetBoxProps })=>{
    var _modulePrivs;
    const { t } = useTranslation();
    const exhibitionistType = useExhibitionistType();
    const isMobile = useContext(MobileContext);
    const { moduleData } = useModuleData(moduleId);
    const { title, sourceType, seeAllUrl, premiumFolderData, deviations, viewMode } = moduleData;
    const isEmpty = deviations.length === 0;
    const hasCore = useSelector(getCurrentUserHasCore);
    const modulePrivs = useModulePrivileges(moduleId);
    const isOwner = (_modulePrivs = modulePrivs) === null || _modulePrivs === void 0 ? void 0 : _modulePrivs.edit;
    const showCoreUpsell = exhibitionistType === ExhibitionistWidgetType.STRIP_SHORT && !hasCore && isOwner;
    const renderContent = ()=>{
        if (isEmpty) {
            return /*#__PURE__*/ React.createElement(ExhibitionistEmpty, {
                moduleId: moduleId
            });
        }
        let content;
        if (isMobile) {
            content = /*#__PURE__*/ React.createElement(ExhibitionistGrid, {
                moduleId: moduleId
            });
        } else if (exhibitionistType === ExhibitionistWidgetType.TALL) {
            const isSlideshow = viewMode === ExhibitionistViewMode.SLIDESHOW;
            content = isSlideshow ? /*#__PURE__*/ React.createElement(ExhibitionistSlideshow, {
                moduleId: moduleId
            }) : /*#__PURE__*/ React.createElement(ExhibitionistGrid, {
                moduleId: moduleId
            });
        } else {
            content = /*#__PURE__*/ React.createElement(ExhibitionistStrip, {
                moduleId: moduleId
            });
        }
        return /*#__PURE__*/ React.createElement(DuperbrowseContext, {
            streamId: EXHIBITIONIST_STRIP_DUPERBROWSE_STREAMID,
            deviations: deviations
        }, content);
    };
    return /*#__PURE__*/ React.createElement(WidgetBox, _object_spread({
        header: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PremiumFolderDataIcon, {
            premiumFolderData: premiumFolderData,
            size: IconSize.COMPACT,
            className: s['premium-folder-icon']
        }), title || t(`widgets.exhibitionist.source.${sourceType}`)),
        headerExtras: sourceType === GallectionType.COLLECTION ? /*#__PURE__*/ React.createElement(FavouritesLabel, null) : undefined,
        seeAllUrl: seeAllUrl,
        moduleId: moduleId
    }, widgetBoxProps), /*#__PURE__*/ React.createElement(ConditionalWrapper, {
        condition: showCoreUpsell,
        wrap: (child)=>/*#__PURE__*/ React.createElement(WidgetPaywall, {
                lockedClassName: s['widget-paywall-locked'],
                title: t('widgets.exhibitionist.coreOnly.paywall.title'),
                subtitle: t('widgets.exhibitionist.coreOnly.paywall.subtitle'),
                buttonAlignment: "horizontal",
                previewReferral: ReferralType.WIDGET_PAYWALL_OVERLAY,
                lockedReferral: ReferralType.WIDGET_PAYWALL_OVERLAY
            }, child)
    }, renderContent()));
};
ExhibitionistBox.displayName = 'ExhibitionistBox';
export default ExhibitionistBox;
